<template>
    <main>
        <header>
            <div class="container">
                <div class="logo-block">
                    <svg id="layer_4" data-name="layer 4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448.43 50.69"><path fill="#1d1d1b"  d="M136,49h-6.12l-1,3.11h-4.29l6.38-17.41h3.92l6.41,17.41H137Zm-1.13-3.47-1.91-5.88h0L131,45.51Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M160.8,34.68V52.09h-4.07v-9.6h0l-3.53,6.4h-2.62L147,42.5h0v9.59h-4.07V34.68H147l4.81,9.22h.07l4.77-9.22Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M176.19,44.43a4.52,4.52,0,0,1,.85,2.8,5.33,5.33,0,0,1-.34,2,4.54,4.54,0,0,1-1,1.53,4.71,4.71,0,0,1-1.76,1,7.3,7.3,0,0,1-2.43.37h-7.64V34.68h6.57a9.62,9.62,0,0,1,2.53.29,5,5,0,0,1,1.79.83,3.51,3.51,0,0,1,1.06,1.34,4.25,4.25,0,0,1,.36,1.8,4.56,4.56,0,0,1-.14,1.11,3.78,3.78,0,0,1-.42,1.06,3.37,3.37,0,0,1-.79,1,4,4,0,0,1-1.18.71v0A4.52,4.52,0,0,1,176.19,44.43Zm-8.33-2.81h1.93a2.69,2.69,0,0,0,1.59-.43A1.4,1.4,0,0,0,172,40a1.46,1.46,0,0,0-.58-1.23,2.77,2.77,0,0,0-1.76-.44h-1.8Zm3.4,6.77a2.71,2.71,0,0,0,.81-.34,1.61,1.61,0,0,0,.53-.57,1.71,1.71,0,0,0,.18-.8,1.61,1.61,0,0,0-.64-1.34,3.12,3.12,0,0,0-1.92-.5h-2.36v3.67h2.36A4.18,4.18,0,0,0,171.26,48.39Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M179.26,34.68h11.37v3.66h-7.35v3.34h5.8v3.6h-5.8v3.16h7.86v3.65H179.26Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M202.55,52.09,199,46.48h-1.43v5.61h-4V34.68h6.79a7.89,7.89,0,0,1,2.77.45,5,5,0,0,1,2,1.26,5.38,5.38,0,0,1,1.11,1.9,7,7,0,0,1,.38,2.4,5.93,5.93,0,0,1-.84,3.25,5,5,0,0,1-2.39,2V46l4.08,6.13Zm-5-9.2h1.89a3.19,3.19,0,0,0,2.07-.62,2,2,0,0,0,.76-1.68,2.09,2.09,0,0,0-.72-1.65,3,3,0,0,0-2-.64h-2Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M233.2,34.68V52.09h-4.07v-9.6h0l-3.53,6.4h-2.62L219.4,42.5h-.05v9.59h-4.06V34.68h4.12l4.81,9.22h.08l4.77-9.22Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M236.35,34.68h4.14V52.09h-4.14Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M258.6,34.68V52.09h-4.23l-6.6-10.43h-.05V52.09h-4.08V34.68h4.1l6.72,10.7h0V34.68Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M261.75,34.68h4.14V52.09h-4.14Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M284,34.68V52.09h-4.22l-6.61-10.43h0V52.09H269V34.68h4.1l6.71,10.7h0V34.68Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M292.5,51.91A8.34,8.34,0,0,1,290,50.79a8.47,8.47,0,0,1-1.93-1.8,7.94,7.94,0,0,1-1.26-2.48,10.19,10.19,0,0,1-.45-3.08,10.07,10.07,0,0,1,.61-3.55A8.39,8.39,0,0,1,288.72,37a7.74,7.74,0,0,1,2.78-1.91,9.91,9.91,0,0,1,7.56.12,8.57,8.57,0,0,1,3.18,2.3L299.35,40a5.77,5.77,0,0,0-4.15-1.73,4.4,4.4,0,0,0-1.74.35,4.22,4.22,0,0,0-1.44,1,4.7,4.7,0,0,0-1,1.63,6.25,6.25,0,0,0-.37,2.17,5.88,5.88,0,0,0,.33,2,5,5,0,0,0,.91,1.63,4.26,4.26,0,0,0,1.49,1.1,4.68,4.68,0,0,0,2,.41,6.11,6.11,0,0,0,3-.78v-2H295V42.34h7.27v7.82a9.48,9.48,0,0,1-3.07,1.53,12.53,12.53,0,0,1-3.85.59A10.73,10.73,0,0,1,292.5,51.91Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M316.42,51.91A8.4,8.4,0,0,1,314,50.79,8.22,8.22,0,0,1,312,49a7.75,7.75,0,0,1-1.27-2.48,10.19,10.19,0,0,1-.45-3.08,10.3,10.3,0,0,1,.61-3.55A8.39,8.39,0,0,1,312.63,37a7.83,7.83,0,0,1,2.78-1.91,9.91,9.91,0,0,1,7.56.12,8.61,8.61,0,0,1,3.19,2.3L323.26,40a5.75,5.75,0,0,0-4.15-1.73,4.43,4.43,0,0,0-1.74.35,4.22,4.22,0,0,0-1.44,1,4.7,4.7,0,0,0-1,1.63,6.25,6.25,0,0,0-.36,2.17,5.87,5.87,0,0,0,.32,2,5,5,0,0,0,.92,1.63,4.13,4.13,0,0,0,1.48,1.1,4.69,4.69,0,0,0,2,.41,6.14,6.14,0,0,0,3-.78v-2h-3.34V42.34h7.27v7.82a9.38,9.38,0,0,1-3.07,1.53,12.47,12.47,0,0,1-3.84.59A10.62,10.62,0,0,1,316.42,51.91Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M337.91,52.09l-3.56-5.61h-1.44v5.61h-4V34.68h6.78a8,8,0,0,1,2.78.45,5,5,0,0,1,1.95,1.26,5.4,5.4,0,0,1,1.12,1.9,7.28,7.28,0,0,1,.37,2.4,5.93,5.93,0,0,1-.83,3.25,5,5,0,0,1-2.4,2V46l4.08,6.13Zm-5-9.2h1.89a3.22,3.22,0,0,0,2.08-.62,2.23,2.23,0,0,0,0-3.33,3,3,0,0,0-2-.64h-2Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M348.78,51.66a8.18,8.18,0,0,1-2.84-1.83A8.27,8.27,0,0,1,344.11,47a10.29,10.29,0,0,1,0-7.2,8.1,8.1,0,0,1,4.67-4.69,10.28,10.28,0,0,1,7.22,0,8,8,0,0,1,4.67,4.66,10.2,10.2,0,0,1,0,7.27,8.3,8.3,0,0,1-1.84,2.84A8.21,8.21,0,0,1,356,51.68a9.78,9.78,0,0,1-3.58.65A9.66,9.66,0,0,1,348.78,51.66Zm6-3.83A4.55,4.55,0,0,0,356.48,46a6,6,0,0,0,0-5.21,4.55,4.55,0,0,0-1.66-1.84,4.43,4.43,0,0,0-2.4-.67A4.49,4.49,0,0,0,350,39a4.59,4.59,0,0,0-1.67,1.85,6,6,0,0,0,0,5.17A4.59,4.59,0,0,0,350,47.82a4.49,4.49,0,0,0,2.43.68A4.43,4.43,0,0,0,354.82,47.83Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M367.79,51.83a6.36,6.36,0,0,1-2.26-1.43A6.3,6.3,0,0,1,364.07,48a9.22,9.22,0,0,1-.52-3.2V34.68h4.13v9.88a5.27,5.27,0,0,0,.2,1.52,4.33,4.33,0,0,0,.56,1.25,2.71,2.71,0,0,0,1,.85,2.9,2.9,0,0,0,1.33.31A2.73,2.73,0,0,0,373,47.43a4.35,4.35,0,0,0,.87-2.87V34.68H378V44.83a9,9,0,0,1-.83,4,6,6,0,0,1-2.47,2.61,7.88,7.88,0,0,1-3.93.93A8.32,8.32,0,0,1,367.79,51.83Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M380.81,34.68h6.62a7.93,7.93,0,0,1,2.77.45,4.88,4.88,0,0,1,1.94,1.26,5.1,5.1,0,0,1,1.11,1.9,7.28,7.28,0,0,1,.37,2.4,6,6,0,0,1-.81,3.21,4.89,4.89,0,0,1-2.26,2,8.57,8.57,0,0,1-3.43.63h-2.28v5.61h-4Zm5.75,8.2a3.2,3.2,0,0,0,2.08-.61,2.05,2.05,0,0,0,.74-1.68,2.11,2.11,0,0,0-.71-1.65,3,3,0,0,0-2.05-.64h-1.78v4.58Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M401.76,36.55a1.45,1.45,0,0,1,2.89,0,1.45,1.45,0,0,1-2.89,0Zm2.42,3.6V52.09h-2V40.15Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M410,40.15v2.16h0A5,5,0,0,1,414.4,40c2.58,0,4.29,1.6,4.29,5v7.09h-2V45.57c0-2.8-1.2-3.75-2.94-3.75-2.26,0-3.73,1.62-3.73,4.31v6h-2V40.15Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M428.89,45V34.69H431V44.86c0,3.21,1.79,5.37,4.61,5.37s4.63-2,4.63-5.37V34.69h2.14V45c0,4.47-2.63,7.24-6.77,7.24S428.89,49.59,428.89,45Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M448.13,34.05V46.67l0,0L454,40.15h2.41L452,45.08l4.51,7h-2.27l-3.61-5.61-2.45,2.64v3h-2v-18Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M460.8,40.15v2.18h.05A4.47,4.47,0,0,1,464.73,40a2.74,2.74,0,0,1,.49,0v2.2c-.3,0-.59,0-.79,0-2.28,0-3.63,1.74-3.63,4.14v5.76h-2V40.15Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M466.32,46.21c0-3.53,2.42-6.21,5.81-6.21a4.76,4.76,0,0,1,4.17,2.28l0,0V40.15h2V52.09h-1.91V49.93h0a4.78,4.78,0,0,1-4.26,2.31A5.7,5.7,0,0,1,466.32,46.21Zm10.1,0a4.06,4.06,0,1,0-8.09,0,4,4,0,1,0,8.09,0Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M481.61,36.55A1.45,1.45,0,1,1,483.06,38,1.43,1.43,0,0,1,481.61,36.55Zm2.43,3.6V52.09h-2V40.15Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M489.9,40.15v2.16h0A5,5,0,0,1,494.26,40c2.57,0,4.29,1.6,4.29,5v7.09h-2V45.57c0-2.8-1.2-3.75-2.94-3.75-2.25,0-3.72,1.62-3.72,4.31v6h-2V40.15Z" transform="translate(-64.22 -12)"/><path fill="#1d1d1b"  d="M512.6,46.72h-9.32a4,4,0,0,0,4.09,3.7,4.26,4.26,0,0,0,3.46-1.59l1.4,1.18a6.2,6.2,0,0,1-11-3.88A5.79,5.79,0,0,1,507.15,40c3.26,0,5.49,2.5,5.49,5.91C512.64,46.23,512.6,46.57,512.6,46.72Zm-9.27-1.62h7.33a3.49,3.49,0,0,0-3.53-3.28A3.78,3.78,0,0,0,503.33,45.1Z" transform="translate(-64.22 -12)"/><polygon fill="#1d1d1b"  points="25.44 6.69 33.65 19.59 35.77 16.25 25.44 0 15.1 16.25 17.23 19.6 25.44 6.69"/><path fill="#1d1d1b"  d="M100.79,29.5,89.65,47l-4.34-6.82a10.71,10.71,0,0,1,6.9-2.52,10.43,10.43,0,0,1,1.78.15L96,34.6a14.29,14.29,0,0,0-12.67,2.55L78.51,29.5,64.22,52H75.29V48.38H70.76l7.75-12.19,2.28,3.59a14.3,14.3,0,0,0,21.33,18.91V46.08h-6l-2.29,3.59h4.72V57A10.71,10.71,0,0,1,82.9,43.09L88.55,52h2.2l10-15.78,7.76,12.19h-4V52h10.52Z" transform="translate(-64.22 -12)"/></svg>
                </div>
                <div class="menu">
                    <ul>
                        <li>
                            <a target=_blank :href="lang+'.pdf'" style="pointer-events: none;opacity: .5">{{t.presentation}}</a>
                        </li>
                        <li><a class="goto_contacts" @click="goto_contacts()">{{t.contacts}}</a></li>
                    </ul>
                </div>
                <div class="lang-selector">
                    <div class="current-language" @click="show_languages=!show_languages">
                        {{current_lang}}
                    </div>
                    <transition name="fade">
                        <div class="dropdown" v-if="show_languages">
                            <ul>
                                <li>
                                    <router-link :to="{name: 'uk'}">UA</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'ru'}">RU</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'en'}">EN</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'cn'}">CN</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'pl'}">PL</router-link>
                                </li>
                            </ul>
                        </div>
                    </transition>
                </div>
                <div class="menu-mobile">
                    <a class="goto_contacts" @click="goto_contacts()">{{t.contacts}}</a>
                    <a target=_blank :href="lang+'.pdf'" style="pointer-events: none;opacity: .5">{{t.presentation}}</a>
                </div>
            </div>
        </header>
        <section id="f1">
            <div class="container"><div class="adelon-logo hide-on-mobile">
                    <svg id="layer_4" data-name="layer 4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.76 74.83"><path fill="#7d8488" d="M92.75,1852H90l-.86-2.59H84.8l-.86,2.59H81.2l4.21-10.94h3.1Zm-7.32-4.53h3.12l-1.36-4c-.09-.3-.16-.54-.21-.74C86.81,1843.38,86.3,1845,85.43,1847.5Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M107,1841.14a6.7,6.7,0,0,1,4.54,1.4,5.75,5.75,0,0,1-.06,8.06,7.31,7.31,0,0,1-4.85,1.43h-3.38v-10.89Zm-.14,9q3.66,0,3.66-3.58t-3.39-3.51h-1.35v7.09Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M131.48,1850.12V1852h-6.87v-10.89h6.87V1843h-4.34v2.39h4v1.89h-4v2.81Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M150.33,1852H143v-10.89h2.54v9h4.83Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M162,1842.4a5.88,5.88,0,0,1,4.24-1.43,5.72,5.72,0,0,1,4.21,1.45,6.64,6.64,0,0,1,0,8.31,6.85,6.85,0,0,1-8.43,0,6.6,6.6,0,0,1,0-8.33Zm4.23.49a2.78,2.78,0,0,0-2.28.93,4.23,4.23,0,0,0-.76,2.75c0,2.45,1,3.67,3,3.67s3-1.22,3-3.67S168.24,1842.89,166.23,1842.89Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M194,1841.14V1852h-3.22l-5.2-8.24h-.07c.1,1.49.15,2.53.15,3.11V1852h-2.26v-10.89h3.19l5.19,8.16h.06c-.08-1.37-.12-2.37-.12-3v-5.15Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M103.1,1865.92a4.82,4.82,0,0,1-.52-.08v-.48a5.88,5.88,0,0,0,.9.09,2.09,2.09,0,0,0,.41,0,.61.61,0,0,0,.26-.15.56.56,0,0,0,.12-.3,3.82,3.82,0,0,0,0-.55c0-.31,0-.53,0-.64a.36.36,0,0,0-.13-.25,1.08,1.08,0,0,0-.37-.13l-.75-.15a.55.55,0,0,1-.36-.21.88.88,0,0,1-.15-.43,6.41,6.41,0,0,1,0-.7,1.81,1.81,0,0,1,.29-1.15,1.18,1.18,0,0,1,1-.35,3.48,3.48,0,0,1,.57,0,2.39,2.39,0,0,1,.38.07v.48a2.22,2.22,0,0,0-.36-.06l-.45,0a1.38,1.38,0,0,0-.46.06.52.52,0,0,0-.25.18.76.76,0,0,0-.1.3,2.81,2.81,0,0,0,0,.45,3.39,3.39,0,0,0,0,.54.41.41,0,0,0,.1.23.58.58,0,0,0,.26.1l.67.14a1.22,1.22,0,0,1,.44.17.6.6,0,0,1,.24.37.68.68,0,0,1,.06.31c0,.13,0,.32,0,.57a3.38,3.38,0,0,1-.11,1,.85.85,0,0,1-.36.51,1.36,1.36,0,0,1-.74.16Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M107.4,1865.89V1861h-1v-.51h2.47v.51h-1v4.91Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M112.39,1865.89l-.31-1.51h-1.26l-.3,1.51H110l1.11-5.42h.76l1.1,5.42Zm-.91-4.7h0l-.53,2.7H112Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M114.77,1860.47H116a1,1,0,0,1,.88.34,1.69,1.69,0,0,1,.26,1,1.89,1.89,0,0,1-.17.87.83.83,0,0,1-.55.41v0a.79.79,0,0,1,.6.43,2,2,0,0,1,.16.9,1.85,1.85,0,0,1-.26,1,1.08,1.08,0,0,1-.95.38h-1.24Zm1.7,2.2a1.22,1.22,0,0,0,.18-.74,2.05,2.05,0,0,0-.06-.57.46.46,0,0,0-.22-.3.83.83,0,0,0-.43-.09h-.63v1.92h.63A.64.64,0,0,0,116.47,1862.67Zm0,2.49a1.33,1.33,0,0,0,.16-.78,1.35,1.35,0,0,0-.17-.77.64.64,0,0,0-.56-.22h-.64v2H116A.64.64,0,0,0,116.52,1865.16Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M119.21,1865.89v-5.42h.56v4.91h1.35v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M122.87,1865.89v-5.42h2.07v.5h-1.52v1.92h1.33v.51h-1.33v2h1.52v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M131.49,1865.89l-.3-1.51h-1.26l-.3,1.51h-.56l1.12-5.42h.75l1.11,5.42Zm-.91-4.7h-.05l-.53,2.7h1.11Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M133.87,1865.89v-5.42h.56v4.91h1.35v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M138.14,1865.89V1861h-1v-.51h2.47v.51h-1v4.91Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M141.45,1865.89v-5.42h2.06v.5H142v1.92h1.32v.51H142v2h1.51v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M147.42,1865.89l-.57-2.16H146v2.16h-.55v-5.42h1.32a1.12,1.12,0,0,1,.75.2.87.87,0,0,1,.31.53,4.37,4.37,0,0,1,.07.9,3.65,3.65,0,0,1-.1,1,.76.76,0,0,1-.44.53l.64,2.29Zm-.29-2.78a.51.51,0,0,0,.17-.34,3.84,3.84,0,0,0,0-.67,3.76,3.76,0,0,0,0-.67.53.53,0,0,0-.17-.34.67.67,0,0,0-.43-.12H146v2.26h.71A.67.67,0,0,0,147.13,1863.11Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M151.93,1865.89l-1.44-4h0v4h-.53v-5.42h.56l1.41,3.94h0v-3.94h.52v5.42Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M156.7,1865.89l-.3-1.51h-1.26l-.3,1.51h-.55l1.11-5.42h.75l1.11,5.42Zm-.91-4.7h0l-.53,2.7h1.11Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M159.29,1865.89V1861h-1v-.51h2.47v.51h-1v4.91Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M162.62,1865.89v-5.42h.55v5.42Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M166,1865.89l-1.05-5.42h.56l.86,4.68h0l.85-4.68h.54l-1.05,5.42Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M169.56,1865.89v-5.42h2.06v.5h-1.51v1.92h1.33v.51h-1.33v2h1.51v.51Z" transform="translate(-81.2 -1791.13)"/><polygon fill="#3e6887" points="12.77 74.76 16.09 69 19.42 74.76 12.77 74.76"/><polygon fill="#3e6887" points="93.55 74.76 96.88 69 100.2 74.76 93.55 74.76"/><polygon fill="#3e6887" points="46.16 17.73 56.39 0 66.63 17.73 46.16 17.73"/><polygon fill="#7d8488" points="49.91 38.12 34.35 38.12 46.14 17.73 46.15 17.73 53.91 31.19 49.91 38.12"/><polygon fill="#7d8488" points="62.85 38.12 58.84 31.19 66.61 17.73 66.62 17.73 78.4 38.12 62.85 38.12"/></svg>
                </div></div>
            <div class="p1">
                <div class="container show-on-mobile">
                <div class="floating-block-1" :class="trigger_1?'shown':''">
                    <div class="header">
                        {{t.fb1_header}}
                    </div>
                    <div class="under-header">
                        <div class="header-2">
                            {{t.fb1_header2}}
                        </div>
                        <div class="long-text" v-html="t.fb1_long_text"></div>
                    </div>
                </div>
            </div>
            </div>
            
            <div class="p2">
                <div class="container">
                    <div class="inner-content" v-html="t.section1"></div>
                </div>
            </div>
            <div class="container hide-on-mobile">
                <div class="floating-block-1" :class="trigger_1?'shown':''">
                    <div class="header">
                        {{t.fb1_header}}
                    </div>
                    <div class="under-header">
                        <div class="header-2">
                            {{t.fb1_header2}}
                        </div>
                        <div class="long-text" v-html="t.fb1_long_text"></div>
                    </div>
                </div>
            </div>
        </section>
        <section id="f2">
            <div class="container">
                <div class="logo" :class="trigger_2?'shown':''"><svg id="layer_4" data-name="layer 4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.11 93.77"><g fill="#7d8488"><polygon fill="#999EA1" points="47.06 12.38 62.24 36.25 66.18 30.06 47.06 0 27.93 30.07 31.87 36.25 47.06 12.38"/><path fill="#999EA1" d="M188.45,65.81l-20.61,32.4-8-12.62a19.75,19.75,0,0,1,12.76-4.67,21,21,0,0,1,3.29.27l3.79-6A26.44,26.44,0,0,0,156.23,80l-9-14.14-26.45,41.57h20.49v-6.64h-8.39l14.35-22.55,4.22,6.63a26.44,26.44,0,0,0,39.45,35V96.48H179.76l-4.22,6.64h8.72v13.6A19.8,19.8,0,0,1,155.35,91l10.46,16.43h4.06l18.58-29.19,14.34,22.55h-7.35v6.64h19.45Z" transform="translate(-120.78 -33.43)"/></g></svg></div>
                <div class="floating-block-2" :class="trigger_2?'shown':''">
                    <div class="arrow-input" v-html="t.fb2_long_text"></div>
                </div>
                <div class="floating-block-3" v-html="t.fb3_header" :class="trigger_2?'shown':''"></div>
                <div class="floating-block-4" :class="trigger_2?'shown':''"></div>
                <div class="floating-block-6"  :class="trigger_2?'shown':''" v-html="t.fb6_long_text"></div>
                <div class="floating-block-5" :class="trigger_2?'shown':''">
                    <div class="arrow-input"  v-html="t.fb5_long_text"></div>
                </div>
                
            </div>
        </section>
        <section id="f3">
            <div class="container">
                <figure class="figure1" :class="trigger_3?'shown':''">
                    <img src="./../assets/6.png" alt="">
                </figure>
                <figure class="figure2"  :class="trigger_3?'shown':''">
                    <img src="./../assets/14.png" alt="">
                </figure>
                <div class="text-container">
                    <div class="floating-block-7" :class="trigger_3?'shown':''"></div>
                    <div class="f3-long-text" v-html="t.f3_long_text"></div>
                </div>
            </div>
        </section>
        <section id="f4">
            <div class="container">
                <h2>{{t.we_offer}}</h2>
                <div class="image-contain" :class="trigger_4?'shown':''">
                    <div class="data-contain">
                        <div class="main-data">
                            <div class="data-title">{{t.f4_data_title}}</div>
                            <div class="flex-section">
                                <div>
                                    <div class="flex-title">
                                        {{t.density}}
                                    </div>
                                    <div class="flex-data">
                                        1.1 - 1.25
                                    </div>
                                </div>
                                <div class="flex-separator"></div>
                                <div>
                                    <div class="flex-title">
                                        {{t.preveling_color}}
                                    </div>
                                    <div class="flex-data">
                                        {{t.yellow}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="side-data">
                            <div class="side-title">
                                {{t.fraction}}
                            </div>
                            <div class="side-content">
                                <div>0-2g </div>
                                <div>2-5g</div>
                                <div>5-10g</div>
                                <div>10-20g</div>
                                <div>20-50g</div>
                                <div>50-100g</div>
                                <div>100-200g</div>
                                <div>200-300g</div>
                                <div>300-500g</div>
                                <div>500-1000g</div>
                                <div>1000g+</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="f4-footer">
                    <div class="logo"><svg id="layer_4" data-name="layer 4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.11 93.77"><g fill="#7d8488"><polygon fill="#525656" points="47.06 12.38 62.24 36.25 66.18 30.06 47.06 0 27.93 30.07 31.87 36.25 47.06 12.38"/><path fill="#525656" d="M182.43,1459l-20.61,32.4-8-12.62a19.71,19.71,0,0,1,16.05-4.39l3.79-6a26.58,26.58,0,0,0-7.07-1,26.31,26.31,0,0,0-16.35,5.67l-9-14.14-26.44,41.57h20.48v-6.64h-8.38l14.34-22.55,4.22,6.63a26.44,26.44,0,0,0,39.45,35v-23.32H173.74l-4.22,6.64h8.72v13.6a19.8,19.8,0,0,1-28.91-25.77l10.46,16.43h4.07l18.57-29.19,14.34,22.55h-7.35v6.64h19.45Z" transform="translate(-114.77 -1426.63)"/></g></svg></div>
                    <div class="volume_title">{{t.volume_of_production}}</div>
                    <div>
                        <div class="vol_2021">
                            {{t.volume_2021}}
                        </div>
                        <div class="vol_2022">
                            <small>{{t.planned_volume}}</small>
                            <div>{{t.volume_2022}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="f5"  :class="trigger_5?'shown':''">
            <div class="map1">{{t.map1}}</div>
            <div class="map2">{{t.map2}}</div>
            <div class="map3">{{t.map3}}</div>
            <div class="map4">{{t.map4}}</div>
            <div class="map5">{{t.map5}}</div>
            <div class="container">
                <div class="floating-block-8" :class="trigger_5?'shown':''">
                    <div class="arrow-input" v-html="t.fb8_long_text"></div>
                </div>
            </div>
        </section>
        <section id="f6">
            <div class="yellow-background">
                <div class="container">
                    <h2 v-html="t.f6_title"></h2>
                    <div class="subtitle" v-html=t.f6_subtitle></div>
                    <div class="subsubtitle" v-html=t.f6_subsubtitle></div>
                </div>
            </div>
            <div class="container">
                <figure >
                    <img src="./../assets/13.png" alt="">
                </figure>
                <div class="table">
                    <div class="header">
                        {{t.last_table_header}}
                    </div>
                    <div class="subheader">
                        <div class="col">

                        </div>
                        <div class="col">
                            {{t.header_col1}}
                        </div>
                        <div class="col">
                            {{t.header_col2}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_1_col_1}}</div>
                        <div class="col">{{t.row_1_col_2}}</div>
                        <div class="col">{{t.row_1_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_2_col_1}}</div>
                        <div class="col">{{t.row_2_col_2}}</div>
                        <div class="col">{{t.row_2_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_3_col_1}}</div>
                        <div class="col">{{t.row_3_col_2}}</div>
                        <div class="col">{{t.row_3_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_4_col_1}}</div>
                        <div class="col">{{t.row_4_col_2}}</div>
                        <div class="col">{{t.row_4_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_5_col_1}}</div>
                        <div class="col">{{t.row_5_col_2}}</div>
                        <div class="col">{{t.row_5_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_6_col_1}}</div>
                        <div class="col">{{t.row_6_col_2}}</div>
                        <div class="col">{{t.row_6_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_7_col_1}}</div>
                        <div class="col">{{t.row_7_col_2}}</div>
                        <div class="col">{{t.row_7_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_8_col_1}}</div>
                        <div class="col">{{t.row_8_col_2}}</div>
                        <div class="col">{{t.row_8_col_3}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{t.row_9_col_1}}</div>
                        <div class="col">{{t.row_9_col_2}}</div>
                        <div class="col">{{t.row_9_col_3}}</div>
                    </div>
                </div>
            </div>
        </section>
        <section id="contacts">
            <div class="container">
                <div class="contacts-flex">
                    <div class="col-left">
                        <figure>
                            <a href="https://goo.gl/maps/dsgURB8tvacYEnhW7" target="_blank"><img src="./../assets/2Vi6iS.png" alt=""></a>
                        </figure>
                        <figure>
                            <a href="https://goo.gl/maps/dsgURB8tvacYEnhW7" target="_blank"><img src="./../assets/0xs4qW.png" alt=""></a>
                        </figure>
                    </div>
                    <div class="col-right">
                        <div class="logo">
                            <img src="./../assets/16.png" alt="">
                        </div>
                        <div class="footer-adelon-logo">
                            <svg id="layer_4" data-name="layer 4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.76 74.83"><path fill="#7d8488" d="M92.75,1852H90l-.86-2.59H84.8l-.86,2.59H81.2l4.21-10.94h3.1Zm-7.32-4.53h3.12l-1.36-4c-.09-.3-.16-.54-.21-.74C86.81,1843.38,86.3,1845,85.43,1847.5Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M107,1841.14a6.7,6.7,0,0,1,4.54,1.4,5.75,5.75,0,0,1-.06,8.06,7.31,7.31,0,0,1-4.85,1.43h-3.38v-10.89Zm-.14,9q3.66,0,3.66-3.58t-3.39-3.51h-1.35v7.09Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M131.48,1850.12V1852h-6.87v-10.89h6.87V1843h-4.34v2.39h4v1.89h-4v2.81Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M150.33,1852H143v-10.89h2.54v9h4.83Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M162,1842.4a5.88,5.88,0,0,1,4.24-1.43,5.72,5.72,0,0,1,4.21,1.45,6.64,6.64,0,0,1,0,8.31,6.85,6.85,0,0,1-8.43,0,6.6,6.6,0,0,1,0-8.33Zm4.23.49a2.78,2.78,0,0,0-2.28.93,4.23,4.23,0,0,0-.76,2.75c0,2.45,1,3.67,3,3.67s3-1.22,3-3.67S168.24,1842.89,166.23,1842.89Z" transform="translate(-81.2 -1791.13)"/><path fill="#7d8488" d="M194,1841.14V1852h-3.22l-5.2-8.24h-.07c.1,1.49.15,2.53.15,3.11V1852h-2.26v-10.89h3.19l5.19,8.16h.06c-.08-1.37-.12-2.37-.12-3v-5.15Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M103.1,1865.92a4.82,4.82,0,0,1-.52-.08v-.48a5.88,5.88,0,0,0,.9.09,2.09,2.09,0,0,0,.41,0,.61.61,0,0,0,.26-.15.56.56,0,0,0,.12-.3,3.82,3.82,0,0,0,0-.55c0-.31,0-.53,0-.64a.36.36,0,0,0-.13-.25,1.08,1.08,0,0,0-.37-.13l-.75-.15a.55.55,0,0,1-.36-.21.88.88,0,0,1-.15-.43,6.41,6.41,0,0,1,0-.7,1.81,1.81,0,0,1,.29-1.15,1.18,1.18,0,0,1,1-.35,3.48,3.48,0,0,1,.57,0,2.39,2.39,0,0,1,.38.07v.48a2.22,2.22,0,0,0-.36-.06l-.45,0a1.38,1.38,0,0,0-.46.06.52.52,0,0,0-.25.18.76.76,0,0,0-.1.3,2.81,2.81,0,0,0,0,.45,3.39,3.39,0,0,0,0,.54.41.41,0,0,0,.1.23.58.58,0,0,0,.26.1l.67.14a1.22,1.22,0,0,1,.44.17.6.6,0,0,1,.24.37.68.68,0,0,1,.06.31c0,.13,0,.32,0,.57a3.38,3.38,0,0,1-.11,1,.85.85,0,0,1-.36.51,1.36,1.36,0,0,1-.74.16Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M107.4,1865.89V1861h-1v-.51h2.47v.51h-1v4.91Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M112.39,1865.89l-.31-1.51h-1.26l-.3,1.51H110l1.11-5.42h.76l1.1,5.42Zm-.91-4.7h0l-.53,2.7H112Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M114.77,1860.47H116a1,1,0,0,1,.88.34,1.69,1.69,0,0,1,.26,1,1.89,1.89,0,0,1-.17.87.83.83,0,0,1-.55.41v0a.79.79,0,0,1,.6.43,2,2,0,0,1,.16.9,1.85,1.85,0,0,1-.26,1,1.08,1.08,0,0,1-.95.38h-1.24Zm1.7,2.2a1.22,1.22,0,0,0,.18-.74,2.05,2.05,0,0,0-.06-.57.46.46,0,0,0-.22-.3.83.83,0,0,0-.43-.09h-.63v1.92h.63A.64.64,0,0,0,116.47,1862.67Zm0,2.49a1.33,1.33,0,0,0,.16-.78,1.35,1.35,0,0,0-.17-.77.64.64,0,0,0-.56-.22h-.64v2H116A.64.64,0,0,0,116.52,1865.16Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M119.21,1865.89v-5.42h.56v4.91h1.35v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M122.87,1865.89v-5.42h2.07v.5h-1.52v1.92h1.33v.51h-1.33v2h1.52v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M131.49,1865.89l-.3-1.51h-1.26l-.3,1.51h-.56l1.12-5.42h.75l1.11,5.42Zm-.91-4.7h-.05l-.53,2.7h1.11Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M133.87,1865.89v-5.42h.56v4.91h1.35v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M138.14,1865.89V1861h-1v-.51h2.47v.51h-1v4.91Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M141.45,1865.89v-5.42h2.06v.5H142v1.92h1.32v.51H142v2h1.51v.51Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M147.42,1865.89l-.57-2.16H146v2.16h-.55v-5.42h1.32a1.12,1.12,0,0,1,.75.2.87.87,0,0,1,.31.53,4.37,4.37,0,0,1,.07.9,3.65,3.65,0,0,1-.1,1,.76.76,0,0,1-.44.53l.64,2.29Zm-.29-2.78a.51.51,0,0,0,.17-.34,3.84,3.84,0,0,0,0-.67,3.76,3.76,0,0,0,0-.67.53.53,0,0,0-.17-.34.67.67,0,0,0-.43-.12H146v2.26h.71A.67.67,0,0,0,147.13,1863.11Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M151.93,1865.89l-1.44-4h0v4h-.53v-5.42h.56l1.41,3.94h0v-3.94h.52v5.42Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M156.7,1865.89l-.3-1.51h-1.26l-.3,1.51h-.55l1.11-5.42h.75l1.11,5.42Zm-.91-4.7h0l-.53,2.7h1.11Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M159.29,1865.89V1861h-1v-.51h2.47v.51h-1v4.91Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M162.62,1865.89v-5.42h.55v5.42Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M166,1865.89l-1.05-5.42h.56l.86,4.68h0l.85-4.68h.54l-1.05,5.42Z" transform="translate(-81.2 -1791.13)"/><path fill="#3e6887" d="M169.56,1865.89v-5.42h2.06v.5h-1.51v1.92h1.33v.51h-1.33v2h1.51v.51Z" transform="translate(-81.2 -1791.13)"/><polygon fill="#3e6887" points="12.77 74.76 16.09 69 19.42 74.76 12.77 74.76"/><polygon fill="#3e6887" points="93.55 74.76 96.88 69 100.2 74.76 93.55 74.76"/><polygon fill="#3e6887" points="46.16 17.73 56.39 0 66.63 17.73 46.16 17.73"/><polygon fill="#7d8488" points="49.91 38.12 34.35 38.12 46.14 17.73 46.15 17.73 53.91 31.19 49.91 38.12"/><polygon fill="#7d8488" points="62.85 38.12 58.84 31.19 66.61 17.73 66.62 17.73 78.4 38.12 62.85 38.12"/></svg>
                        </div>
                        <div class="contact-details">
                            <div class="contact-name">
                                Cheng Lin
                            </div>
                            <div class="contact-description">
                                {{t.representative}}
                            </div>
                            <div class="contact-phone">
                                +86 134 3975 3898
                            </div>
                            <div class="contact-email">
                                <a href="mailto:chenglin_linda@aliyun.com">chenglin_linda@aliyun.com</a>
                            </div>
                        </div>
                        <div class="messangers">
                            <a target=_blank href="https://api.whatsapp.com/send?phone=380984769463&text=amber.com.ua"><img src="./../assets/19.png" alt="Whatsapp"></a>
                            <a target=_blank href="viber://add?number=380984769463"><img src="./../assets/17.png" alt="Viber"></a>
                            <a target=_blank href="tg://resolve?domain=380984769463"><img src="./../assets/18.png" alt="Telegram"></a>
                        </div>
                        <div class="messangers-span">+380984769463</div>
                        <div class="socials">
                            <div>
                                <a target=_blank href="weixin://dl/chat?AmberUkraine2020"><img src="./../assets/20.png" alt="WeChat"></a>
                                <span>AmberUkraine2020</span>
                            </div>
                            <div>
                                <a target=_blank href="https://instagram.com/AmberUkraine2020"><img src="./../assets/21.png" alt="Instagram"></a>
                                <span>AmberUkraine2020</span>
                            </div>
                            <div>
                                <a target=_blank href="https://fb.com/AmberUkrain"><img src="./../assets/22.png" alt="Facebook"></a>
                                <span>AmberUkrain</span>
                            </div>
                        </div>
                        <div class="address" v-html="t.address"></div>
                    </div>
                </div>
            </div>
        </section>
        <footer>
            <div class="container">
                <div class="email">
                    <img src="./../assets/24.png" alt="">
                    <a href="mailto:amberukraine2020@gmail.com">amberukraine2020@gmail.com</a>
                </div>
                <div class="amber">
                    <img src="./../assets/pyCFSq.png" alt="">
                </div>
                <div class="website">
                    <span>amber.com.ua</span>
                </div>
            </div>
        </footer>
    </main>
</template>
<script>
let ru = require('./../i18n/ru')
let uk = require('./../i18n/uk')
let en = require('./../i18n/en')
let cn = require('./../i18n/cn')
let pl = require('./../i18n/pl')
export default {
  data(){
    return {
      lang: 'uk',
      t: {},

      show_languages: false,
      trigger_1: false,
      trigger_2: false,
      trigger_3: false,
      trigger_4: false,
      trigger_5: false,
    }
  },
  mounted(){
    this.load_lang()
    let s1 = 1
    let s2 = document.querySelector('section#f2').offsetTop
    let s3 = document.querySelector('section#f3').offsetTop
    let s4 = document.querySelector('section#f4').offsetTop
    let s5 = document.querySelector('section#f5').offsetTop
    let s6 = document.querySelector('section#f6').offsetTop
    document.addEventListener('scroll', ()=>{
        if(window.scrollY>=s1 - 50)
            this.trigger_1 = true
        else
            this.trigger_1 = false
        if(window.scrollY>=s2 - 50)
            this.trigger_2 = true
        else
            this.trigger_2 = false
        if(window.scrollY>=s3 - 50)
            this.trigger_3 = true
        else
            this.trigger_3 = false
        if(window.scrollY>=s4 - 50)
            this.trigger_4 = true
        else
            this.trigger_4 = false
        if(window.scrollY>=s5 - 50)
            this.trigger_5 = true
        else
            this.trigger_5 = false
        if(window.scrollY>=s6 - 50)
            this.trigger_6 = true
        else
            this.trigger_6 = false
    })
    setTimeout(()=>{
        this.trigger_1 = true
    }, 100)
  },
  methods: {
      reset_triggers(){
          this.trigger_1 = false
        //   this.trigger_2 = false
      },
      load_lang(){
            this.lang = this.$route.name;
            this.show_languages = false;
            this.reset_triggers()
            setTimeout(()=>{
                this.trigger_1 = true
            }, 1000)
            
            switch(this.lang){
                case 'ru': this.t = ru; break;
                case 'uk': this.t = uk; break;
                case 'en': this.t = en; break;
                case 'cn': this.t = cn; break;
                case 'pl': this.t = pl; break;
            }
      },
      goto_contacts(){
          window.scrollTo(0, document.querySelector('#contacts').offsetTop)
      }
  },
  computed: {
      current_lang(){
        if(this.lang == 'uk')
            return 'ua'
        return this.lang
      }
  },
  watch: {
    $route:{
      deep: true,
      handler(){
        this.load_lang()
      }
    }
  }
} 
</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
        }



    html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
    }

    /* Sections
    ========================================================================== */

    /**
    * Remove the margin in all browsers.
    */

    body {
    margin: 0;
    }

    /**
    * Render the `main` element consistently in IE.
    */

    main {
    display: block;
    }

    /**
    * Correct the font size and margin on `h1` elements within `section` and
    * `article` contexts in Chrome, Firefox, and Safari.
    */

    h1 {
    font-size: 2em;
    margin: 0.67em 0;
    }

    /* Grouping content
    ========================================================================== */

    /**
    * 1. Add the correct box sizing in Firefox.
    * 2. Show the overflow in Edge and IE.
    */

    hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
    }

    /**
    * 1. Correct the inheritance and scaling of font size in all browsers.
    * 2. Correct the odd `em` font sizing in all browsers.
    */

    pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
    }

    /* Text-level semantics
    ========================================================================== */

    /**
    * Remove the gray background on active links in IE 10.
    */

    a {
    background-color: transparent;
    }

    /**
    * 1. Remove the bottom border in Chrome 57-
    * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
    */

    abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
    }

    /**
    * Add the correct font weight in Chrome, Edge, and Safari.
    */

    b,
    strong {
    font-weight: bolder;
    }

    /**
    * 1. Correct the inheritance and scaling of font size in all browsers.
    * 2. Correct the odd `em` font sizing in all browsers.
    */

    code,
    kbd,
    samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
    }

    /**
    * Add the correct font size in all browsers.
    */

    small {
    font-size: 80%;
    }

    /**
    * Prevent `sub` and `sup` elements from affecting the line height in
    * all browsers.
    */

    sub,
    sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
    }

    sub {
    bottom: -0.25em;
    }

    sup {
    top: -0.5em;
    }

    /* Embedded content
    ========================================================================== */

    /**
    * Remove the border on images inside links in IE 10.
    */

    img {
    border-style: none;
    }

    /* Forms
    ========================================================================== */

    /**
    * 1. Change the font styles in all browsers.
    * 2. Remove the margin in Firefox and Safari.
    */

    button,
    input,
    optgroup,
    select,
    textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
    }

    /**
    * Show the overflow in IE.
    * 1. Show the overflow in Edge.
    */

    button,
    input {
    /* 1 */
    overflow: visible;
    }

    /**
    * Remove the inheritance of text transform in Edge, Firefox, and IE.
    * 1. Remove the inheritance of text transform in Firefox.
    */

    button,
    select {
    /* 1 */
    text-transform: none;
    }

    /**
    * Correct the inability to style clickable types in iOS and Safari.
    */

    button,
    [type='button'],
    [type='reset'],
    [type='submit'] {
    -webkit-appearance: button;
    }

    /**
    * Remove the inner border and padding in Firefox.
    */

    button::-moz-focus-inner,
    [type='button']::-moz-focus-inner,
    [type='reset']::-moz-focus-inner,
    [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
    }

    /**
    * Restore the focus styles unset by the previous rule.
    */

    button:-moz-focusring,
    [type='button']:-moz-focusring,
    [type='reset']:-moz-focusring,
    [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
    }

    /**
    * Correct the padding in Firefox.
    */

    fieldset {
    padding: 0.35em 0.75em 0.625em;
    }

    /**
    * 1. Correct the text wrapping in Edge and IE.
    * 2. Correct the color inheritance from `fieldset` elements in IE.
    * 3. Remove the padding so developers are not caught out when they zero out
    *    `fieldset` elements in all browsers.
    */

    legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
    }

    /**
    * Add the correct vertical alignment in Chrome, Firefox, and Opera.
    */

    progress {
    vertical-align: baseline;
    }

    /**
    * Remove the default vertical scrollbar in IE 10+.
    */

    textarea {
    overflow: auto;
    }

    /**
    * 1. Add the correct box sizing in IE 10.
    * 2. Remove the padding in IE 10.
    */

    [type='checkbox'],
    [type='radio'] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
    }

    /**
    * Correct the cursor style of increment and decrement buttons in Chrome.
    */

    [type='number']::-webkit-inner-spin-button,
    [type='number']::-webkit-outer-spin-button {
    height: auto;
    }

    /**
    * 1. Correct the odd appearance in Chrome and Safari.
    * 2. Correct the outline style in Safari.
    */

    [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
    }

    /**
    * Remove the inner padding in Chrome and Safari on macOS.
    */

    [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
    }

    /**
    * 1. Correct the inability to style clickable types in iOS and Safari.
    * 2. Change font properties to `inherit` in Safari.
    */

    ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
    }

    /* Interactive
    ========================================================================== */

    /*
    * Add the correct display in Edge, IE 10+, and Firefox.
    */

    details {
    display: block;
    }

    /*
    * Add the correct display in all browsers.
    */

    summary {
    display: list-item;
    }

    /* Misc
    ========================================================================== */

    /**
    * Add the correct display in IE 10+.
    */

    template {
    display: none;
    }

    /**
    * Add the correct display in IE 10.
    */

    [hidden] {
    display: none;
    }
    header{
        background: #F49500;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        font-style: 14px;
    }
    .container{
        max-width: 1100px;
        margin: 0 auto;
        position: relative;
    }
    .logo-block{
        width: 35%;
        padding: 10px 0;
    }
    header .container{
        display: flex;
        align-items: center;
        /* justify-content: space-between; */
    }
    header .menu{
        margin-left: auto;
    }
    header .menu ul{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    header .menu ul li{
        float: left;
    }
    header .menu ul li a, header .menu-mobile a{
        color: #FFF7B2;
        text-transform: uppercase;
        padding: 0 15px;
        text-decoration: none;
    }
    .lang-selector{
        margin-left: 15px;
        cursor: pointer;
    }
    .lang-selector .current-language{
        text-transform: uppercase;
        color: #FFF7B2;
        border: 1px solid #FFF7B2;
        border-radius: 20px;
        padding: 5px 10px;
    }
    .lang-selector .dropdown{
        position: absolute;
        background: #F49500;
        padding: 15px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-left: -10px;
        z-index: 1234;
    }
    .lang-selector .dropdown ul{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .lang-selector .dropdown ul a{
        color: #FFF7B2;
        padding: 5px;
        text-decoration: none;
        display: block;
    }
    #f1 .p1{
        margin-top: -2px;
        background-image: url(./../assets/CIsN0c.png); 
        height: 1000px;
        background-repeat: no-repeat;
        background-size: cover;
    }
    #f1{
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
    #f1 .p2{
        background-color: #F49500;
        min-height: 553px;
        display: flex;
        align-items: center;
    }
    #f1 .p2 .inner-content{
        padding: 30px 0;
        width: 45%;
    }
    #f1 .p2 .inner-content p{
        line-height: 1.5em;
    }
    #f1 .floating-block-1{
        position: absolute;
        right: 0;
        bottom: 0;
        transform: translateY(1000px);
        opacity: 0;
        transition: all 2s;
    }
    #f1 .floating-block-1.shown{
        opacity: 1;
        transform: translateY(0);
    }
    #f1 .floating-block-1 .under-header{
        background-image: url(./../assets/2.png);
        width: 407px;
        height: 1421px;
        background-repeat: no-repeat;
        background-size: contain;
    }
    #f1 .floating-block-1 .header{
        color: #F49500;
        font-size: 30px;
        white-space: nowrap;
        text-transform: uppercase;
        text-align: center;
        width: 407px;
        margin-bottom: 10px;

    }
    div.under-header {
        position: relative;
    }
    div.under-header > div.header-2{
        color: #FFF7B2;
        font-size: 32px;
        opacity: .75;
        text-transform: uppercase;
        text-align: center;
        width: 407px;
        position: absolute;
        top: 571px;
    }
    div.under-header > div.long-text{
        color: #FFF7B2;
        font-size: 22px;
        text-align: left;
        width: 407px;
        position: absolute;
        top: 680px;
        left: 5vw;
    }
    #f2 {
        background-color: #0B0D0C;
        background-image: url(./../assets/d3B9e7.png);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: bottom center;
        min-height: 1833px;
    }
    #f2 .logo{
        opacity: .47;
        width: 100px;
        position: absolute;
        top: 100px;
        opacity: 0;
        transition: all 2s;
    }
    #f2 .logo.shown{
        opacity: 1;
    }
    #f2{
        perspective: 1000px;
    }
    .floating-block-2{
        position: absolute;
        right: 20px;
        top: 0;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        transform: rotateX(90deg);
        transition: all 2s;
        transition-delay: 1s;
        transform-origin: top;
        -webkit-backface-visibility: hidden; /* Safari */
        backface-visibility: hidden;
        perspective: 1000px;
        transform-style: preserve-3d;
    }
    .floating-block-2.shown{
        transform: translateY(0) rotateZ(0);
    }
    .floating-block-2 .arrow-input{
        background: #FFF7B2;
        padding: 50px;
        box-sizing: border-box;
        width: 372px;
    }
    .floating-block-2 .arrow-input:after{
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 25px 25px;
        border-color: transparent transparent #FFF7B2 transparent;
        position: absolute;
        left: -25px;
        bottom: 0;
    }
    .floating-block-3{
        position: absolute;
        top: 220px;
        font-weight: bold;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        color: #F49500;
        font-size: 44px;
        height: 0;
        overflow: hidden;
        transition: all 2s;
        /* transition-delay: .5s; */
    }
    .floating-block-3.shown{
        height: 100%;
    }
    .floating-block-4{
        background: url(./../assets/4.png);
        width: 214px;
        height: 215px;
        position: absolute;
        top: 460px;
    }
    .floating-block-4.shown{
        animation: pulsing 5s infinite;
    }
    @keyframes pulsing {
        0% {
            transform: scale(1) rotateZ(0);
        }
        50% {
            transform: scale(1.1) rotateZ(10deg);
        }
    }
    @keyframes pulsing2 {
        0% {
            transform: scale(1) rotateZ(0);
        }
        50% {
            transform: scale(.9) rotateZ(-10deg);
        }
    }
    @keyframes typing {
    from { width: 0 }
    to { width: 100% }
    }
    #f2 .container{
        min-height: 1833px;
    }
    .floating-block-5{
        position: absolute;
        right: 20px;
        bottom: 14vw;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        transition: all 1s;
        opacity: 0;
    }
    .floating-block-5.shown{
        opacity: 1;
    }
    .floating-block-5 .arrow-input{
        background: #F49500;
        padding: 50px;
        color: #FFF7B2;
        box-sizing: border-box;
        width: 372px;
    }
    .floating-block-5 .arrow-input:after{
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 25px 25px;
        border-color: transparent transparent #F49500 transparent;
        position: absolute;
        left: -25px;
        bottom: 0;
    }
    .floating-block-6{
        position: absolute;
        top: 400px;
        left: 400px;
        font-weight: bold;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        color: #FFF7B2;
        font-size: 24px;
    }
    .floating-block-6 div{
        overflow: hidden;
        width: 0;
        transition: all 1s;
        
    }
    .floating-block-6 div:nth-child(1){
        transition-delay: 1s;
    }
    .floating-block-6 div:nth-child(2){
        transition-delay: 2s;
    }
    .floating-block-6 div:nth-child(3){
        transition-delay: 3s;
    }
    .floating-block-6 div:nth-child(4){
        transition-delay: 4s;
    }
    .floating-block-6 div:nth-child(5){
        transition-delay: 5s;
    }
    .floating-block-6 div:nth-child(6){
        transition-delay: 6s;
    }
    .floating-block-6 div:nth-child(7){
        transition-delay: 7s;
    }
    .floating-block-6 div:nth-child(8){
        transition-delay: 8s;
    }
    .floating-block-6 div:nth-child(10){
        transition-delay: 10s;
    }
    .floating-block-6.shown div{
        width: 100%;
    }
    #f3{
        background: #0B0D0C;
        padding: 25px 0;
        overflow-x: hidden;
        perspective: 1000px;
    }
    figure{
        margin: 0;
        margin-bottom: 30px;
    }
    .figure1{
        transition: all 1s;
        transform: translateX(-1000px) rotateY(30deg);
        opacity: 0;
    }
    .figure2{
        transition: all 1s;
        transform: translateX(1000px) rotateY(-30deg);
        opacity: 0;
    }
    .figure1.shown, .figure2.shown{
        transform: translateX(0);
        opacity: 1;
    }
    figure img{
        width: 100%;
        height: auto;
        display: block;
    }
    #f3 .text-container{
        display: flex;
        color: #FFF7B2;
        font-family: Verdana, Geneva, Tahoma, sans-serif;

    }
    #f3 .floating-block-7{
        background: url(./../assets/7.png);
        flex-basis: 231px;
        flex-shrink: 0;
        height: 312px;
        margin-right: 40px;
    }
    #f3 .floating-block-7.shown{
        animation: pulsing2 5s infinite;
    }
    #f4{
        background-color: #F49500;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        padding: 25px;
    }
    #f4 h2{
        text-align: center;
    }
    #f4 .image-contain{
        background-image: url(./../assets/8.png);
        width: 1029px;
        height: 1271px;
        margin: 0 auto;
        opacity: 0;
        transition: all 3s;
    }
    #f4 .image-contain.shown{
        opacity: 1;
    }
    #f4 .main-data{
        position: absolute;
        top: 650px;
        color: #F49500;
        text-align: center;
        width: 809px;
        font-weight: bold;
    }
    #f4 .main-data .flex-section{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
    }
    #f4 .main-data .flex-section .flex-separator{
        background-color: #FFF7B2;
        width: 1em;
        height: 2em;
        margin: 0 2em;
    }
    #f4 .main-data .flex-title{
        color: #FFF7B2;
        font-weight: normal;
    }
    #f4 .main-data .flex-data{
        font-size: 20px;
    }
    #f4 .side-data{
        position: absolute;
        margin-left: 819px;
        width: 210px;
        margin-top: 100px;
        text-align: center;
    }
    #f4 .side-data .side-title{
        text-transform: uppercase;
        color: #FFF7B2;
        font-size: 22px;
        font-weight: bold;
    }
    #f4 .side-data .side-content div{
        color: #F49500;
        padding: 30px 0;
        font-weight: bold;
    }
    #f4 .f4-footer .logo{
        opacity: .77;
        width: 100px;
    }
    #f4 .f4-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 25px;
    }
    #f4 .f4-footer .volume_title{
        text-transform: uppercase;
        font-size: 24px;
        font-weight: bold;
    }
    #f4 .f4-footer .vol_2021{
        font-size: 24px;
        font-weight: bold;
        padding-bottom: 5px;
        border-bottom: 1px solid black;
    }
    #f4 .f4-footer .vol_2022{
        font-size: 24px;
        font-weight: bold;
        padding-top: 5px;
    }
    #f4 .f4-footer .vol_2022 small{
        font-size: 14px;
        font-weight: normal;
    }
    #f5{
        background-image: url(./../assets/9.png);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: left top;
        height: 78.4vw;
        margin-top: -2px;
        position: relative;
        transition: all 2s;
        transition-delay: 1s;
        filter: blur(10px);
        transform: scaleY(1.1);
    }
    #f5.shown{
        filter: blur(0);
        transform: scaleY(1);
        perspective: 1000px;
    }
    .floating-block-8{
        position: absolute;
        right: 20px;
        top: 2px;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        transform-origin: bottom left;
        transition: all 2s;
        transition-delay: 2s;
        transform: rotateX(-15deg) rotateY(-60deg) rotateX(-60deg) scale(.4);
    }
    .floating-block-8.shown{
        transform: none;
    }
    .floating-block-8 .arrow-input{
        background: #F49500;
        padding: 50px;
        color: #FFF7B2;
        box-sizing: border-box;
        width: 372px;
        right: 0;
    }
    .floating-block-8 .arrow-input:after{
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 25px 25px;
        border-color: transparent transparent #F49500 transparent;
        position: absolute;
        left: -25px;
        bottom: 0;
    }
    [class*="map"]{
        font-weight: bold;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        color: #FFF7B2;
        font-style: italic;
        position: absolute;
    }
    .map1{
        top: 17vw;
        left: 34vw;
    }
    .map2{
        top: 34vw;
        left: 34vw;
    }
    .map3{
        top: 44vw;
        left: 47vw;
    }
    .map4{
        top: 65vw;
        left: 40vw;
    }
    .map5{
        top: 36vw;
        left: 15vw;
    }
    #f6{
        background-image: url(./../assets/12.png);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top center;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
    #f6 .yellow-background{
        background-color: #F49500;
        background-image: url(./../assets/10.png);
        background-repeat: no-repeat;
        background-size: 101%;
        background-position: -2px 102%;
        padding: 25px 0;
        text-align: center;
    }
    #f6 .subtitle{
        font-style: italic;
        color: #FFF7B2;
        margin-bottom: 15px;
    }
    #f6 .subsubtitle{
        font-size: 20px;
        color: #FFF7B2;
        margin-bottom: 7.5vw;
    }
    #f6 figure{
        margin-top: -7vw;
    }
    #f6 .table .row{
        display: flex;
        justify-content: space-between;
        margin-bottom: .5vw;
    }
    #f6 .table .header{
        background-color: #F49500;
        text-align: center;
        font-weight: bold;
        font-size: 22px;
        padding: 10px 0;
    }
    #f6 .table .subheader{
        display: flex;
        justify-content: space-between;
        margin-bottom: .5vw;
        margin-top: .5vw;
        font-weight: bold;
    }
    #f6 .table .subheader .col{
        background:rgba(255, 247, 178, .6);
        padding: 15px;
        box-sizing: border-box;
    }
    #f6 .table .row .col{
        background:rgba(255, 247, 178, .47);
        padding: 15px;
        box-sizing: border-box;
    }
    #f6 .table .row > .col:first-child, #f6 .table .subheader > .col:first-child{
        flex-basis: 26%;
    }
    #f6 .table .row > .col:nth-child(2), #f6 .table .row > .col:nth-child(3), #f6 .table .subheader > .col:nth-child(2), #f6 .table .subheader > .col:nth-child(3){
        flex-basis: 36%;
    }
    #contacts{
        background-color: #0B0D0C;
        text-align: center;
        padding: 100px 0;
        margin-top: -10px;
    }
    #contacts .logo{
        margin-bottom: 50px;
    }
    #contacts .messangers{
        
        display: flex;
        justify-content: center;
    }
    #contacts .messangers a{
        display: block;
        margin: 0 5px;
    }
    #contacts .messangers-span{
        display: block;
        margin-bottom: 40px;
        flex-basis: 100%;
        color: #FFF7B2;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        margin-top: 10px;
    }
    #contacts .socials{
        margin-bottom: 40px;
    }
    #contacts .socials:before, #contacts .address:before{
        width: 100px;
        content: '';
        height: 1;
        display: block;
        margin: 0 auto;
        margin-bottom: 40px;
        border-top: 1px solid #FFF7B2;
    }
    #contacts .socials div{
        color: #FFF7B2;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        margin-bottom: 10px;
    }
    #contacts .socials div span{
        display: block;
        margin-top: 5px;
    }
    #contacts .address{
        color: #FFF7B2;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    footer{
        background: #0B0D0C;
    }
    footer .container{
        display: flex;
        align-items: flex-end;
    }
    footer .container .amber{
        margin: 0 40px;
    }
    footer .container .email img{
        display: block;
    }
    footer .container .email a{
        color: #FFF7B2;
        text-decoration: none;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
    footer .container .website, footer .container .email{
        padding-bottom: 100px;
    }
    footer .container .website span{
        background: #F49500;
        color: #0B0D0C;
        padding: 10px;
        font-weight: bold;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        font-size: 20px;
    }
    .goto_contacts{
        cursor: pointer;
    }
    @media screen and (max-width: 1100px){
        section{
            overflow-x: scroll;
        }
        
    }
    .menu-mobile, .show-on-mobile{
        display: none;
    }
    .adelon-logo{
        position: absolute;
        top: 30px;
        width: 100px;
    }
    .footer-adelon-logo{
        width: 150px;
        margin: 0 auto;
        margin-bottom: 50px;
    }
    #contacts .contact-details{
        color: #FFF7B2;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        margin-bottom: 100px;
    }
    #contacts .contact-details div{
        margin: 5px auto;
    }
    #contacts .contact-details div a{
        color: #FFF7B2;
        text-decoration: none;
    }
    #contacts .contact-description{
        color: #3E6887;
        font-style: italic;
    }
    .contacts-flex{
        display: flex;
    }
    .contacts-flex .col-left, .contacts-flex .col-right{
        flex-basis: 50%;
    }
    @media screen and (max-width: 768px){
        .contacts-flex{
            display: block;
        }
        footer .container{
            display: block;
        }
        header .container{
            flex-wrap: wrap;
        }
        header .logo-block{
            width: 75%;
            margin-left: 5%;
        }
        header .menu{
            display: none;
        }
        img{
            max-width: 100%;
        }
        .menu-mobile{
            display: block;
            width: 100%;
            text-align: center;
            padding-bottom: 10px;
        }
        #f3 .text-container{
            display: block;
            padding: 0 5%;
        }
        #f3 .floating-block-7{
            margin: 0 auto;
            background-repeat: no-repeat;
        }
        #f4 .f4-footer{
            display: block;
        }
        #f5{
            background-size: contain;
            background-position: bottom left;
            height: calc(78.4vw + 230px);
        }
        .map1{
            top: calc(17vw + 230px);
        }
        .map2{
            top: calc(34vw + 230px);
        }
        .map3{
            top: calc(44vw + 230px);
        }
        .map4{
            top: calc(65vw + 230px);
        }
        .map5{
            top: calc(38vw + 230px);
        }
        #f6 .table .row > .col:nth-child(2), #f6 .table .row > .col:nth-child(3), #f6 .table .subheader > .col:nth-child(2), #f6 .table .subheader > .col:nth-child(3), #f6 .table .row > .col:nth-child(1), #f6 .table .subheader > .col:nth-child(1){
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .floating-block-8{
            position: absolute;
            height: 230px;
            margin-bottom: 230px;
            overflow: hidden;
            width: 100%;
            right: 0;
            top: 0;
        }
        .floating-block-8 .arrow-input{
            width: 100%;
        }
        footer .container .website, footer .container .email{
            text-align: center;
        }
        footer .container .email{
            padding-top: 10px;
        }
        footer .container .email img{
            display: block;
            margin: 0 auto;
            margin-bottom: 10px;
        }
        /* #f2 .container{
            padding-top: 260px;
        }
        .floating-block-2{
            height: 260px;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
        }
        .floating-block-2 .arrow-input{
            width: 100%;
        } */
        #f2{
            overflow: hidden;
        }
        #f2 [class*="floating-block-"], #f2 [class*="logo"]{
            position: static !important;
            width: 100% !important;
            padding: 0 5%;
            margin: 10px 0;
            transform: none !important;
            box-sizing: border-box;
        }
        #f2 svg{
            width: 100px;
            margin: 10px auto;
        }
        #f2 [class*="floating-block-"] .arrow-input{
            width: 100%;
        }
        #f1{
            overflow: hidden;
        }
        #f1 [class*="floating-block-"], #f1 [class*="logo"]{
            position: static !important;
            width: 100% !important;
            padding: 0 5%;
            margin: 10px 0;
            transform: none !important;
            box-sizing: border-box;
        }
        #f1 svg{
            width: 100px;
            margin: 10px auto;
        }
        #f1 [class*="floating-block-"] .arrow-input{
            width: 100%;
        }
        .hide-on-mobile{
            display: none;
        }
        .show-on-mobile{
            display: block;
        }
        #f1 .floating-block-1 .under-header{
            width: 100%;
            height: 500px;
            background-size: cover;
        }
        #f1 .floating-block-1 .header, div.under-header > div.header-2{
            width: 100%;
            font-size: 26px !important;
        }
        div.under-header > div.header-2{
            top: 480px;
        }
        div.under-header > div.long-text{
            background: #0B0D0C;
            padding: 5%;
            box-sizing: border-box;
            left: 0;
            right: 0;
            top: 520px;
            width: 100%;;
        }
        #f1 .floating-block-1,
        #f1 .floating-block-1.shown{
            position: absolute !important;
            top: 70px;
            transform: none !important;
        }
        #f1 .p2{
            min-height: unset;
        }
        #f1 .p2 .inner-content{
            width: 100%;
            padding: 30px 5%;
            box-sizing: border-box;
        }
    }
</style>